import React from 'react';
import { Stack, Button } from '@stepstone-genesis/components';
const StarterButtons = ({ btns, onClick, amaConversationID, disabled, }) => {
    return (React.createElement(Stack, { direction: 'vertical', flxItems: 'start', spacing: 'spaceS' }, btns.map((str) => (React.createElement(Button, { key: str, a11yLabel: 'Conversation Starter Button', variant: "secondary", size: "small", disabled: disabled, "data-atx-onclick-payload": JSON.stringify({
            linkName: 'suggestedQuestionClick',
            componentState: 'conversationStarted',
            elementActioned: 'suggestedQuestion',
            elementAction: 'click',
            elementActionValue: str,
            amaConversationID: amaConversationID || 'noValue',
        }), onClick: () => onClick?.(str), sx: {
            textAlign: 'left',
            textWrap: 'wrap',
            display: 'block',
            height: 'auto',
        } }, str)))));
};
const MetaHandler = ({ actions, onStarterButtonClick, amaConversationID, disabled, }) => (React.createElement(React.Fragment, null, actions.map((action, idx) => {
    if (action.starterButtons) {
        return (React.createElement(StarterButtons, { key: `btns_${idx}`, btns: action.starterButtons, onClick: onStarterButtonClick, amaConversationID: amaConversationID, disabled: disabled }));
    }
    return null;
})));
export default MetaHandler;
